import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'
import { MotionMask } from 'src/theme/styled'

import ActionButton from '../ActionButton'
import Icon from '../Icon'

import { BlockTitleVariant } from './types'

export const Container = styled.header<{
  $variant?: BlockTitleVariant
}>`
  ${({ theme }) => theme.textStyles.d1440_body}
  --gap--vertical: ${({ $variant }) =>
    $variant === BlockTitleVariant.buttoned ? pxToRem(32) : pxToRem(56)};

  position: relative;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  gap: var(--gap--vertical);
  padding-block-start: ${pxToRem(24)};

  @media ${mq(sizes.desktop)} {
    --gap--vertical: ${pxToRem(16)};
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
  }
`

export const Tag = styled.p`
  ${({ theme }) => theme.textStyles.d1440_button}
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: ${pxToRem(8)};
  text-align: nowrap;
  white-space: nowrap;
  overflow: hidden;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.d1440_h4}
  }
`

export const TagContent = styled(motion.span)`
  display: inline-block;
`

export const TagIcon = styled(Icon)<{ $color?: string }>`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(12)};
  color: ${({ $color }) => $color};
`
export const Title = styled.h2<{ $variant?: BlockTitleVariant }>`
  ${({ theme }) => theme.textStyles.m375_h1}
  text-wrap: balance;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    --width: ${({ $variant }) =>
      $variant === BlockTitleVariant.tagged ||
      $variant === BlockTitleVariant.buttoned
        ? `calc(2 / 3 * 100%)`
        : `calc(1 / 2 * 100%)`};
    ${({ theme }) => theme.textStyles.d1440_h1}
    &:not(:only-child) {
      flex: 0 1 auto;
      width: 100%;
      max-width: var(--width);
    }
  }
`

export const TitleContent = styled(motion.span)`
  display: inline-block;
`

export const RichTextMask = styled(MotionMask)`
  @media ${mq(sizes.desktop)} {
    flex: 0 1 auto;
    width: 100%;
    max-width: calc(1 / 3 * 100%);
  }
`

export const _ActionButton = styled(ActionButton)`
  @media ${mq(sizes.desktop)} {
    white-space: nowrap;
  }
`
